import React from 'react'
import ftr from './footer.module.css'

export default function Footer() {
    return (
        <footer className={ftr.footer}>
            <span>&copy;<a href="https://www.gingertonic.io" target="_blank">Gingertonic</a> 2020</span>     
        </footer>
    )
}